<template lang="html">
  <b-form class="form-horizontal" @submit.prevent="submitForm">
    <b-card no-body>
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <tab-item icon="list" heading="Step 1" subheading="Details"></tab-item>
          </template>
          <b-container fluid>
            <b-row>


              <b-col md="3">
                <strong>Details</strong>
                <p class="muted">Enter the general details of this opportuinty here.</p>
                <p class="muted">After a contract is created, <strong>Start Date</strong> and <strong>End Date</strong>
                  can only
                  be changed by uploading a new contract or addendum file.</p>
                <p class="muted">The <strong>Contract Restrictions</strong> cannot be changed after the contract is
                  created.
                  Instead, a new contract should be created to indicate those changes. </p>
              </b-col>

              <b-col md="9">

                <b-form-group label="Name" label-class="control-label required" label-for="name"
                  :class="{ 'invalid-group': $v.form.name.$error }">
                  <b-form-input id="name" type="text" v-model="form.name"
                    :class="{ 'form-control': true, 'is-invalid': $v.form.name.$error }" placeholder="Enter name">
                  </b-form-input>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.name.$error">You must enter a name.</span>
                </b-form-group>

                <b-form-group label="Legal Name" label-class="control-label" label-for="legalName"
                  :class="{ 'invalid-group': $v.form.legalName.$error }">
                  <b-form-input id="legalName" type="text" v-model="form.legalName"
                    :class="{ 'form-control': true, 'is-invalid': $v.form.legalName.$error }"
                    placeholder="Enter legal name">
                  </b-form-input>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.legalName.$error">The legal name must be
                    below 250
                    characters.</span>
                </b-form-group>

                <b-form-group label="Status" label-class="control-label" v-if="isContractManager"
                  :class="{ 'invalid-group': $v.form.currentContractStatusId.$error }">
                  <b-form-select id="statusInput" v-model="form.currentContractStatusId" :options="statusDefinitions"
                    value-field="contractStatusDefinitionId" text-field="name"></b-form-select>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.currentContractStatusId.$error">Please
                    select a
                    status.</span>
                </b-form-group>

                <b-form-group label="Stage" label-class="control-label" v-if="isContractManager"
                  :class="{ 'invalid-group': $v.form.currentContractStageId.$error }">
                  <b-form-select id="stageInput" v-model="form.currentContractStageId" :options="stageDefinitions"
                    value-field="contractStageDefinitionId" text-field="name"></b-form-select>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.currentContractStageId.$error">Please
                    select a
                    stage.</span>
                </b-form-group>

                <b-form-group label="Agreement Type" label-class="control-label"
                  :class="{ 'invalid-group': $v.form.contractAgreementTypeId.$error }">
                  <b-form-select id="agreementTypes" v-model="form.contractAgreementTypeId" :options="agreementTypes"
                    value-field="contractAgreementTypeId" text-field="name"></b-form-select>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.contractAgreementTypeId.$error">Please
                    select an
                    agreement type.</span>
                </b-form-group>

                <b-form-group label="Sites" label-class="control-label"
                  :class="{ 'invalid-group': $v.form.contractSites.$error }">
                  <autocomplete :source="sitesApi" placeholder="Search sites"
                    :inputClass="{ 'form-control': true, 'is-invalid': $v.form.contractSites.$error }"
                    resultsValue="siteId" :resultsDisplay="siteDisplay" @selected="selectSite" credentials="include"
                    ref="siteAutocomplete" clearAfterEntry :request-headers="requestHeaders"></autocomplete>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.contractSites.$error">You must select at
                    least one
                    site.</span>
                  <div class="site-list">
                    <div v-for="contractSite in form.contractSites" :key="contractSite.contractSiteId">
                      <b-badge variant="primary" class="site-badge" @click="removeContractSite(contractSite)">
                        <font-awesome-icon icon="times" /> {{ contractSite.site.name + " (" + contractSite.siteId + ")"
                        }}
                      </b-badge>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group label="Dean Signature Date" label-class="control-label">
                  <datepicker v-model="form.dateDeanSignature" class="top" :inputClass="{ 'form-control': true }"
                    :typeable="true" format="MM/dd/yyyy"></datepicker>
                </b-form-group>

                <b-form-group label="Date to Agency" label-class="control-label">
                  <datepicker v-model="form.dateToAgency" class="top" :inputClass="{ 'form-control': true }"
                    :typeable="true" format="MM/dd/yyyy"></datepicker>
                </b-form-group>


              </b-col>

            </b-row>
          </b-container>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item icon="user-graduate" heading="Step 2" subheading="Restriction"></tab-item>
          </template>
          <b-container fluid>
            <b-row>


              <b-col md="3">
                <strong>Contract Restrictions</strong>
                <p class="muted">
                  Select a restriction type for this contract.</p>
                <b-list-group>
                  <b-list-group-item><strong>University-wide:</strong> available to any student</b-list-group-item>
                  <b-list-group-item><strong>Restricted:</strong> limited to students from specified programs. Selecting
                    this
                    option will allow selecting the plans allowed for this contract.</b-list-group-item>
                </b-list-group>
              </b-col>

              <b-col md="9">
                <b-form-group label="Restriction Type" label-class="font-weight-bold"
                  :class="{ 'invalid-group': $v.form.contractRestrictionTypeId.$error }">
                  <b-form-select id="restrictionTypes" @change="setRestrictionType"
                    v-model="form.contractRestrictionTypeId" :options="restrictionTypes"
                    value-field="contractRestrictionTypeId" text-field="description"></b-form-select>
                  <span class="span-feedback invalid-feedback" v-if="$v.form.contractRestrictionTypeId.$error">Please
                    select a
                    status.</span>
                </b-form-group>

                <div v-if="showAllPlans" id="planList">
                  <div v-for="college in colleges" :key="college.collegeId">
                    <b-form-checkbox name="colleges" v-model="contractColleges" :value="college.collegeId"
                      @change="changeCollege(college.collegeId)">{{ college.name }}</b-form-checkbox>
                    <div class="ml-4" v-for="plan in college.academicPlans" :key="plan.academicPlanId"
                      v-if="hasCollege(college.collegeId)">
                      <b-form-checkbox name="plans" v-model="form.contractAcademicPlans" :value="{
                        academicPlanId: plan.academicPlanId,
                        contractId: form.contractId,
                        academicPlan: {
                          academicPlanId: plan.academicPlanId,
                          collegeId: plan.collegeId
                        }
                      }">
                        {{ plan.description }} ( {{ plan.planCode }} )
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </b-col>

            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-button class="btn-primary pull-right save-contract-button" @click="saveContract()">Save</b-button>
  </b-form>
</template>

<script>
import TabItem from "../menu/tab-item";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import contractApi from "../../api/contracts";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../../misc/role-checks";

export default {
  name: "contract-form",
  mixins: [roleChecks],
  props: {
    contract: {
      type: Object,
      required: false
    },
    statusDefinitions: {
      type: Array,
      required: true
    },
    stageDefinitions: {
      type: Array,
      required: true
    },
    agreementTypes: {
      type: Array,
      required: true
    },
    restrictionTypes: {
      type: Array,
      required: true
    },
    colleges: {
      type: Array,
      required: true
    },
    copy: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    contract: function () {
      var that = this;
      this.form = this.contract;
      this.form.currentContractStatusId = this.contract.currentContractStatus.contractStatusDefinitionId;
      this.form.currentContractStageId = this.contract.currentContractStage.contractStageDefinitionId;
      _.forEach(this.contract.contractAcademicPlans, function (value) {
        if (
          that.contractColleges.indexOf(value.academicPlan.collegeId) === -1
        ) {
          that.contractColleges.push(value.academicPlan.collegeId);
        }
      });

      this.form.contractAcademicPlans = _.map(
        this.contract.contractAcademicPlans,
        function (plan) {
          return {
            academicPlanId: plan.academicPlanId,
            contractId: plan.contractId,
            academicPlan: {
              academicPlanId: plan.academicPlanId,
              collegeId: plan.academicPlan.collegeId
            }
          };
        }
      );
    }
  },
  mounted() { },
  data() {
    return {
      form: {
        contractId: 0,
        name: null,
        legalName: null,
        contractAgreementTypeId: null,
        contractSites: [],
        startDate: null,
        endDate: null,
        dateDeanSignature: null,
        dateToAgency: null,
        currentContractStatusId: null,
        currentContractStageId: null,
        contractRestrictionTypeId: null,
        contractAcademicPlans: []
      },
      contractColleges: [],
      contractPlans: [],
      showPlanList: false,
      sitesFound: true,
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  validations: function () {
    var validate = {
      form: {
        name: {
          required,
          maxLength: maxLength(250)
        },
        legalName: {
          required,
          maxLength: maxLength(250)
        },
        contractSites: {
          required,
          minLength: minLength(1)
        },
        currentContractStatusId: {},
        currentContractStageId: {},
        contractAgreementTypeId: {
          required
        },
        contractRestrictionTypeId: {
          required
        }
      }
    };
    if (this.form.contractId > 0 && this.isContractManager) {
      validate.form.currentContractStatusId = {
        required
      };
      validate.form.currentContractStageId = {
        required
      };
    }
    return validate;
  },

  methods: {
    saveContract: function () {
      this.$v.$touch();

      if (!this.$v.$error) {
        //if (this.copy || this.contract) {
        this.form.contractStatuses = [
          {
            contractId: this.form.contractId,
            contractStatusDefinitionId: this.form.currentContractStatusId || 0
          }
        ];
        this.form.contractStages = [
          {
            contractId: this.form.contractId,
            contractStageDefinitionId: this.form.currentContractStageId || 0
          }
        ];
        //}

        if (this.copy) {
          this.submitCopiedContract();
        } else if (this.contract) {
          // if contract prop has been used, call edit function
          this.submitEditedContract();
        } else {
          // otherwise, add it as a new site
          this.submitNewContract();
        }
      }
    },
    submitNewContract: function () {
      var that = this;
      if (!this.$v.$error) {
        contractApi
          .postContract(this.form)
          .then(function (response) {
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("The contract has been saved.", "Success");

            // redirect
            that.$router.push({
              name: "contract",
              params: { id: response.data }
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    submitEditedContract: function () {
      var that = this;
      if (!this.$v.$error) {
        contractApi
          .postEditContract(this.form)
          .then(function (response) {
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("The contract has been saved.", "Success");

            // redirect
            that.$router.push({
              name: "contract",
              params: { id: response.data }
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    submitCopiedContract: function () {
      var that = this;
      if (!this.$v.$error) {
        contractApi
          .postCopyContract(this.form)
          .then(function (response) {
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("The contract has been saved.", "Success");

            // redirect
            that.$router.push({
              name: "contract",
              params: { id: response.data }
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    selectSite: function (autoselectResponse) {
      // check if site has already been added
      var found = _.find(this.form.contractSites, function (
        selectedContractSite
      ) {
        return (
          selectedContractSite.siteId ===
          autoselectResponse.selectedObject.siteId
        );
      });
      if (!found) {
        var contractSite = {
          siteId: autoselectResponse.selectedObject.siteId,
          site: {
            siteId: autoselectResponse.selectedObject.siteId,
            name: autoselectResponse.selectedObject.name
          }
        };
        this.form.contractSites.push(contractSite);
      }
    },
    removeContractSite: function (contractSite) {
      this.form.contractSites = _.reject(this.form.contractSites, function (
        selectedContractSite
      ) {
        return selectedContractSite.siteId === contractSite.siteId;
      });
    },
    siteDisplay: function (site) {
      return site.name + " (" + site.siteId + ")";
    },
    setRestrictionType: function (obj) {
      var type = _.find(this.restrictionTypes, function (restriction) {
        return restriction.contractRestrictionTypeId === obj;
      });

      if (type.allowAllPlans) {
        // if unrestricted, show every plan, but don't display the plan list
        //this.showPlanList = false;
        this.setAllAcademicPlans();
      } else {
        // if restricted, show plan list and make sure both arrays are empty
        this.contractColleges = [];
        this.form.contractAcademicPlans = [];
        //this.showPlanList = true;
      }
    },
    setAllAcademicPlans: function () {
      // loop through all available plans
      var that = this;
      _.forEach(this.colleges, function (college) {
        that.contractColleges.push(college.collegeId);
        _.forEach(college.academicPlans, function (plan) {
          var contractPlan = {
            academicPlanId: plan.academicPlanId,
            contractId: that.form.contractId,
            academicPlan: {
              academicPlanId: plan.academicPlanId,
              collegeId: plan.collegeId
            }
          };
          if (that.form.contractAcademicPlans.indexOf(contractPlan) == -1) {
            that.form.contractAcademicPlans.push(contractPlan);
          }
        });
      });
    },
    hasCollege: function (id) {
      return this.contractColleges.indexOf(id) > -1;
    },
    hasAcademicPlan: function (id) {
      if (this.form.contractAcademicPlans) {
        return _.map(this.form.contractAcademicPlans, function (plan) {
          return plan.academicPlanId;
        }).indexOf(id);
      }
      return -1;
    },
    changeCollege: function (collegeId) {
      // if checked, add all college plans, else remove them

      if (this.contractColleges.indexOf(collegeId) === -1) {
        //this.contractColleges.push(collegeId);
        //this.setCollegeAcademicPlans(collegeId);
      } else {
        //remove college from the list
        var index = this.contractColleges.indexOf(collegeId);
        if (index > -1) {
          //this.contractColleges.splice(index, 1);
        }

        this.removeCollegeAcademicPlans(collegeId);
      }
    },
    setCollegeAcademicPlans: function (collegeId) {
      // loop through all available plans
      var that = this;
      _.forEach(this.colleges, function (college) {
        if (college.collegeId == collegeId) {
          // if self doesn't have academic plan, mock up object and add to vm.formData.ContractAcademicPlans
          _.forEach(college.academicPlans, function (plan) {
            var contractPlan = {
              academicPlanId: plan.academicPlanId,
              contractId: that.form.contractId,
              academicPlan: {
                academicPlanId: plan.academicPlanId,
                collegeId: plan.collegeId
              }
            };
            if (that.form.contractAcademicPlans.indexOf(contractPlan) == -1) {
              that.form.contractAcademicPlans.push(contractPlan);
            }
          });
        }
      });
    },
    removeCollegeAcademicPlans: function (collegeId) {
      this.form.contractAcademicPlans = _.reject(
        this.form.contractAcademicPlans,
        function (plan) {
          return plan.academicPlan.collegeId === collegeId;
        }
      );
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    sitesApi: function () {
      return process.env.VUE_APP_BASE_URI + "/api/Sites/FindSite?query=";
    },
    showAllPlans: function () {
      var that = this;
      var type = _.find(this.restrictionTypes, function (restriction) {
        return (
          restriction.contractRestrictionTypeId ===
          that.form.contractRestrictionTypeId
        );
      });
      if (type) {
        return !type.allowAllPlans;
      }

      return false;
    }
  },
  components: {
    "tab-item": TabItem
  },
  created() { }
};
</script>

<style scoped>
.span-feedback.invalid-feedback {
  display: block;
}

.invalid-group {
  color: #dc3545;
}
</style>

<style>
label.required:after {
  content: "*";
  color: #dc3545;
  font-weight: bold;
}

.autocomplete__box.form-control {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}

.top .vdp-datepicker__calendar {
  position: absolute;
  top: -282px;
}

.site-list {
  font-size: 16px;
}

.site-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}
</style>
